import SchoolIcon from "@material-ui/icons/School";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import StarIcon from "@material-ui/icons/Star";

const Education = () => {
  const items = [
    {
      cardTitle: "National School of Computer Science ENSI",
      cardSubtitle: "Computer Science Engineering Degree + Master's Degree",
    
     // coursesHead: "Competences: ",
     /* cardDetailedText: [
        "C",
        "C++",
        "Java",
        "Software Engineering",
        "Software Architecture",
        "Computer Network",
        "Artificial Intelligence",
        "Web Development",
      ].map(function (course) {
        return <li>{course}</li>;
      }),*/
      date: "2022 - 2025",
    },
  
    {
      cardTitle: "Preparatory Institute for Engineering Studies of Nabeul",
      cardSubtitle: "Technologie",
      /*coursesHead: "Competences: ",
      cardDetailedText: [
        "Python",
        "Database Management",
        "SQL",
      ].map(function (course) {
        return <li>{course}</li>;
      }), */  
      date: "2020 - 2022",
    },
    {
      cardTitle: "Abdelaziz Khouja High School, Kelibia",
      cardSubtitle: "Technical Baccalaureate",
      //coursesHead: "Competences: ",
     // cardDetailedText: "Algorithmic",
      date: "2016 - 2020",
    },

    
    
  ];

  return (
    <section id="education" class="about background-alt">
      <div class="container" data-aos="fade-up">
        <div class="section-title">
          <h2>Education</h2>
        </div>

        <div class="row">
          <div class="col-lg-12 d-flex justify-content-center">
            <VerticalTimeline className="custom-line">
              {items.map((data, i) => (
                <VerticalTimelineElement
                  key={i}
                  className="vertical-timeline-element--work"
                  contentStyle={{ background: "#343a40" }}
                  date={data.date}
                  dateClassName="timeline-date"
                  contentArrowStyle={{
                    borderRight: "7px solid  rgb(33, 150, 243)",
                  }}
                  iconStyle={{
                    background: "#0563bb",
                    color: "#fff",
                  }}
                  icon={<SchoolIcon />}
                >
                  <h3
                    className="vertical-timeline-element-title"
                    style={{
                      fontSize: "14",
                      color: "rgba(255, 255, 255, 0.8)",
                    }}
                  >
                    {data.cardTitle}
                  </h3>
                  <h4
                    className="vertical-timeline-element-subtitle"
                    style={{
                      fontSize: "1.2em",
                      fontWeight: "350",
                      color: "#7e8890",
                      marginTop: "5px",
                    }}
                  >
                    {data.cardSubtitle}
                  </h4>
                  <h5
                    className="vertical-timeline-element-subtitle"
                    style={{
                      fontSize: "1em",
                      fontWeight: "250",
                      color: "#7e8890",
                      marginTop: "5px",
                    }}
                  >
                    {data.coursesHead}
                  </h5>
                  <p
                    style={{
                      fontSize: "1em",
                      fontWeight: "350",
                      color: "#74808a",
                    }}
                  >
                    {data.cardDetailedText}
                  </p>
                </VerticalTimelineElement>
              ))}
              <VerticalTimelineElement
                iconStyle={{
                  background: "#0563bb",
                  color: "#fff",
                }}
                icon={<StarIcon />}
              />
            </VerticalTimeline>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
